import { ISuccessIndicatorItem } from './SuccessIndicatorItem';
import styles from './SuccessIndicators.module.scss';
import PlayButton from '../Video/PlayButton';
import Img from '../Img';

interface ISuccessIndicatorVideo extends ISuccessIndicatorItem {
  videoPreview: string;
  showVideo: () => void;
}

const SuccessIndicatorsVideoItem = ({
  title,
  text,
  videoPreview,
  showVideo,
}: ISuccessIndicatorVideo) => (
  <div className={styles.videoItem}>
    <div className={styles.content}>
      <h3 className='header2'>{title}</h3>
      <p className={styles.videoItemText}>{text}</p>
    </div>
    <div className={styles.buttonWrapper}>
      <Img
        src={videoPreview}
        width={200}
        height={200}
        alt='video preview'
        className={styles.previewImage}
      />
      <PlayButton
        isPlaying={false}
        playButtonClassName={styles.playButton}
        onClick={showVideo}
      />
    </div>
  </div>
);

export default SuccessIndicatorsVideoItem;
